import { useEffect } from 'preact/hooks';
import { useDispatch } from 'react-redux';

import { useSelector } from '@/redux/helper';
import { trackMP } from '@/shared/mp';

import MembersOnlyWarningModal from '..';
import { setMembersOnlyWarningModalState } from './actions';

const ConnectedMembersOnlyWarningModal = () => {
  const dispatch = useDispatch();
  const logged = useSelector((state) => state.user.logged);
  const { visible, type, imageUrl, redirectOnDismiss } = useSelector((state) => state.modals.membersOnlyWarningModal);
  const onDismiss = () => dispatch(setMembersOnlyWarningModalState(null));

  useEffect(() => {
    if (visible) {
      trackMP('page-view', {
        currentPage: `MembersOnlyWarningModal.${type || 'general'}`,
        pageType: 'Modal',
      });
    }
  }, [visible, type]);

  if (!visible) return null;

  const defaultProfilePicture = 'https://zoolife.tv/assets/defaultLockedFeatureImage1.webp';
  const profilePicture = type === 'download-media' ? defaultProfilePicture : imageUrl;

  let titleText = '*Gasp*, this is for members-only!';
  let secondaryLink;
  switch (type) {
    case 'download-media':
      titleText = '*Gasp*, this feature is for members-only!';
      break;
    case 'habitat':
      titleText = "You've Picked a Premium Habitat!";
      secondaryLink = { href: '/habitats', label: 'Explore All Animals' };
      break;
    case 'event':
      titleText = '*Gasp*, this event is for members-only!';
      secondaryLink = { href: '/schedule', label: 'Explore Events Calendar' };
      break;
    default:
      secondaryLink = { href: '/habitats', label: 'Explore as a guest' };
  }

  return (
    <MembersOnlyWarningModal
      profilePicture={profilePicture ?? defaultProfilePicture}
      onClickOutside={redirectOnDismiss ? undefined : onDismiss}
    >
      <div>
        <MembersOnlyWarningModal.Title className="px-6">{titleText}</MembersOnlyWarningModal.Title>
        <MembersOnlyWarningModal.Content>
          Unlock full access to all of zoolife.
          <br />
          50% of funds goes to help the animals.
        </MembersOnlyWarningModal.Content>
      </div>
      <MembersOnlyWarningModal.ButtonsContainer>
        <a
          href={logged ? '/plans' : '/prices'}
          className="preflight preflight-a h-12 rounded-full bg-primary-green p-4 text-center text-base font-medium leading-none text-white hover:bg-secondary-green"
          onClick={onDismiss}
        >
          Become a member
        </a>
        {secondaryLink && (
          <a
            href={secondaryLink.href}
            className="preflight preflight-a h-12 rounded-full border border-primary-green p-4 text-center text-base font-medium leading-none text-primary-green hover:bg-beige-light"
            onClick={onDismiss}
          >
            {secondaryLink.label}
          </a>
        )}
        <div className="p-4 text-center">
          {redirectOnDismiss ? (
            <a
              href="/home"
              className="preflight preflight-a inline-block border-b border-current text-base font-medium leading-none text-grey-3 hover:text-grey-1"
              onClick={onDismiss}
            >
              Back to home page
            </a>
          ) : (
            <button
              type="button"
              className="preflight preflight-button inline-block border-b border-current text-base font-medium leading-none text-grey-3 hover:text-grey-1"
              onClick={onDismiss}
            >
              Dismiss
            </button>
          )}
        </div>
      </MembersOnlyWarningModal.ButtonsContainer>
    </MembersOnlyWarningModal>
  );
};

export default ConnectedMembersOnlyWarningModal;
